<template>
    <div class="card-container">
        <div class="card-header">
            <p class="day-information">{{weekday}}</p>
            <div>
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="disableEditScheduling"
                    @click="editScheduling(scheduling)">
                </el-button>
                <el-popconfirm
                    v-if="displayDeleteButton"
                    confirm-button-text='OK'
                    cancel-button-text='No'
                    icon="el-icon-info"
                    icon-color="red"
                    title="Are you sure to delete this scheduling?"
                    @confirm="deleteScheduling"
                >
                    <el-button
                        slot="reference"
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                    >
                    </el-button>
                </el-popconfirm>
                <el-popconfirm
                    v-else
                    confirm-button-text='OK'
                    cancel-button-text='No'
                    icon="el-icon-info"
                    icon-color="red"
                    title="Are you sure to stop this scheduling?"
                    @confirm="stopScheduling"
                >
                    <el-button
                        slot="reference"
                        size="mini"
                        type="danger"
                        icon="el-icon-circle-close"
                        :loading="loading"
                    >
                        Stop now
                    </el-button>
                </el-popconfirm>
            </div>
        </div>
        <div class="informations">
            <div class="information-block">
                <p class="information-title">STARTED AT</p>
                <strong class="dates">{{startDate}}</strong>
                <div class="dates-container">
                    <strong class="dates">{{startTimeUTC}}</strong>
                    <p class="small">UTC 0</p>
                </div>
                <div class="dates-container">
                    <strong class="dates">{{startTimeLocal}}</strong>
                    <p class="small">LOCAL TIME</p>
                </div>
            </div>
            <div class="information-block">
                <p class="information-title">WILL END AT</p>
                <strong class="dates">{{endDate}}</strong>
                <div class="dates-container">
                    <strong class="dates">{{endTimeUtc}}</strong>
                    <p class="small">UTC 0</p>
                </div>
                <div class="dates-container">
                    <strong class="dates">{{endTimeLocal}}</strong>
                    <p class="small">LOCAL TIME</p>
                </div>
            </div>
            <div
                v-if="schedulingStarted"
                class="information-block"
            >
                <p class="information-title">REMAINING TIME</p>
                <div class="dates-container">
                    <strong class="dates">{{remainingTime}}</strong>
                    <p class="small">MIN</p>
                </div>
            </div>
            <div
                v-else
                class="information-block"
            >
                <p class="information-title">DURATION</p>
                <div class="dates-container">
                    <strong class="dates">{{duration}}</strong>
                    <p class="small">MIN</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {

    name: 'scheduling-card',
    props:{
        scheduling:{
            type: Object,
            reqiured: true
        }
    },
    data () {
        return {
            disableEditScheduling: false,
            remainingTimeInterval: null,
            remainingTime: 0,
            remainingTimeDays: '',
            timeUntilStart: 0,
            duration: 0,
            loading: false,
            stopSchedulingTimeoutId: null,
        };
    },
    computed: {
        weekday(){
            let weekday = moment(this.scheduling.start_date).isoWeekday();
            if(weekday === 1) return this.remainingTimeDays = 'Monday';
            if(weekday === 2) return this.remainingTimeDays = 'Tuesday';
            if(weekday === 3) return this.remainingTimeDays = 'Wednesday';
            if(weekday === 4) return this.remainingTimeDays = 'Thursday';
            if(weekday === 5) return this.remainingTimeDays = 'Friday';
            if(weekday === 6) return this.remainingTimeDays = 'Saturday';
            if(weekday === 7) return this.remainingTimeDays = 'Sunday';
        },
        startDate (){
            let date = this.scheduling.start_date;
            return  moment.utc(date).format('YYYY.MM.DD');
        },
        endDate (){
            let date = this.scheduling.end_date;
            return  moment.utc(date).format('YYYY.MM.DD');
        },
        startTimeUTC (){
            let date = this.scheduling.start_date;
            return  moment.utc(date).format('HH:mm');
        },
        startTimeLocal (){
            let date = this.scheduling.start_date;
            return  moment(date).format('HH:mm');
        },
        endTimeUtc (){
            let date = this.scheduling.end_date;
            return  moment.utc(date).format('HH:mm');
        },
        endTimeLocal (){
            let date = this.scheduling.end_date;
            return  moment(date).format('HH:mm');
        },
        displayDeleteButton(){
            if(this.scheduling.status !== 'RUNNING'){
                return true;
            }
            return false;
        },
        schedulingStarted(){
            if(this.scheduling.status === 'RUNNING'){
                this.getRemainingTime();
                return true;
            }
            this.getDuration();
            return false;
        }
    },
    mounted(){
        this.getRemainingTime();
    },
    beforeDestroy(){
        clearInterval(this.remainingTimeInterval);
    },
    methods: {
        editScheduling(selectedScheduling){
            this.$emit('edit-scheduling', selectedScheduling);
        },
        deleteScheduling(){
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.scheduling.uid,
                    url: this.scheduling.url,
                    archived: true,
                },
                model: 'schedulings'
            }).then(() => {
                this.$notify.success({
                    title: 'Success',
                    message: 'Scheduling has been deleted'
                });
                this.$emit('on-archived-reload');
            }).catch(() => {
                this.$notify.error({
                    title: 'Error',
                    message: 'Scheduling couldn\'t be deleted'
                });
            });

        },
        stopScheduling(){
            this.loading = true;
            this.$store.dispatch('createItem', {
                item: {
                    action: 'STOP',
                    scheduling_uid: this.scheduling.uid,
                    start_date: this.scheduling.start_date,
                    end_date: moment.utc(),
                },
                scopes: {'X-Entity-Uid': this.scheduling.scopes.entity_uid},
                model: 'schedulingModificationRequest',
                url: this.$store.state.api.meta.listModels.schedulingModificationRequest.url
            }).then((res) => {
                this.watchSchedulingsModificationRequest(res.url);
            });
        },
        watchSchedulingsModificationRequest(requestUrl){
            this.loading = true;
            clearTimeout(this.stopSchedulingTimeoutId);
            this.$store.dispatch('remoteGet', {
                url: requestUrl
            }).then(res => {
                if (res.data && ['COMPLETED'].includes(res.data.status)) {
                    this.$message({
                        message: `Scheduling successfully stopped!`,
                        type: 'success'
                    });
                    this.loading = false;
                    this.$emit('on-scheduling-stopped');
                }
                else if (res.data && ['FAILED'].includes(res.data.status)) {
                    console.error(res.data.verbose_status);
                    this.$message.error(`Error on stop scheduling`);
                    
                    this.loading = false;
                } else {
                    this.stopSchedulingTimeoutId = setTimeout(() => {
                        this.watchSchedulingsModificationRequest(requestUrl);
                    }, 3000);
                }
            });
        },
        getDuration(){
            let endTime = moment.utc(this.scheduling.end_date);
            let startTime = moment.utc(this.scheduling.start_date);
            this.duration = Math.round(moment.duration(endTime.diff(startTime)).asMinutes());
        },
        getRemainingTime(){
            this.remainingTimeInterval = setInterval(()=>{
                let now = moment.utc();
                let endTime = moment.utc(this.scheduling.end_date);
                let startTime = moment.utc(this.scheduling.start_date);
                if(endTime > now) {
                    this.remainingTime = Math.round(moment.duration(endTime.diff(now)).asMinutes());
                }
                if(now >= endTime) {
                    this.duration = Math.round(moment.duration(endTime.diff(startTime)).asMinutes());
                    this.schedulingFinished = true;
                }
                if(this.remainingTime <= 0){
                    clearInterval(this.remainingTimeInterval);
                    this.remainingTime = 0;
                }
                if(this.remainingTime <= 5){
                    this.disableEditScheduling = true;
                }
                if(this.remainingTime <= 30){
                    this.$emit('set-disable-edit-start-date', this.scheduling.uid);
                }
            }, 5000);
        },

    }
};
</script>

<style lang="css" scoped>
.card-container{
    background-color: #222223;
    padding: 1em;
    margin-bottom: 1em;

}
.card-header{
    display: flex;
    justify-content: space-between;
}
.day-information{
    font-weight: bold;
    font-size: 16px;
}
.information-block{


}
.informations{
    display: flex;
    justify-content: space-between;
    margin-top: 2em;
}
.information-title{
    text-transform: uppercase;
    font-size: 9px;
    color: #BBBBBB;
    margin-bottom: 0.2em;
}
.small{
    font-family: 'roboto';
    font-size: 9px;
    font-weight: normal;
    margin-top: 0.3em;
    margin-left: 0.5em;
    margin-bottom: 0;
}
.dates{
    font-weight: bold;
    font-size: 12px;
    display: block;
}
.dates-container{
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/SchedulingsView/scheduling-card.vue